export const filterSelectableDefaultTees = (tees, courseHoles) => (
  Object.keys(courseHoles || {}).length === 0 ? tees : tees.filter(tee => tee.side === 'all_18')
)

export const filterTeesByGender = (tees, gender) =>
  tees.filter(tee => [ '', null, gender ].includes(tee.gender))
